module.exports = __webpack_public_path__ + "img/6d6e8ac1f2e93350c48e80bdfd375935.png";